/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import PlacesAutocomplete, {
  geocodeByAddress,
  Suggestion,
} from 'react-places-autocomplete'
import Input from '../Input'
import splitAddressComponents, { Place } from './helpers/splitAddressComponents'
import { useState } from 'react'
import getAddressPartial, { AddressObj } from './helpers/getAddressPartial'
import { TextFieldProps } from '../Input'
import {
  SuggestionContent,
  SuggestionItem,
  SuggestionWrapper,
  Wrapper,
} from './styles'
import { P } from '../../styles/Elements'

interface LocationSearchInputProps
  extends Omit<TextFieldProps, 'onChange' | 'value'> {
  onChange: (address: AddressObj) => void
  value: AddressObj
}

const LocationSearchInput: React.FC<LocationSearchInputProps> = ({
  value,
  onChange,
  theme = 'light',
  ...props
}) => {
  const [addressPartial, setAddressPartial] = useState(getAddressPartial(value))

  const handleSelect = async (address: string = addressPartial) => {
    try {
      const results = await geocodeByAddress(address)
      const locationValues = splitAddressComponents({
        place: results[0] as Place,
      })

      onChange({
        address1: locationValues.address1?.trim(),
        city: locationValues.city?.trim(),
        state: locationValues.state?.trim(),
        country: locationValues.country?.trim(),
        zipCode: locationValues.zipCode?.trim(),
      })

      const newAddressPartial = getAddressPartial(locationValues)

      setAddressPartial(newAddressPartial)
    } catch (error) {
      onChange({
        address1: '',
        city: '',
        state: '',
        country: '',
        zipCode: '',
      })
    }
  }

  return (
    <PlacesAutocomplete
      value={addressPartial || ''}
      onChange={setAddressPartial}
      onSelect={handleSelect}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps }) => (
        <Wrapper>
          <Input
            {...props}
            {...getInputProps({
              onBlur: props.onBlur,
            })}
            autoComplete="new-password"
            theme={theme}
          />
          {!!suggestions[0] && (
            <SuggestionWrapper dolaTheme={theme}>
              <SuggestionContent dolaTheme={theme}>
                {suggestions.map((suggestion, i) => {
                  return (
                    <SuggestionItem
                      {...getSuggestionItemProps(suggestion as Suggestion)}
                      dolaTheme={theme}
                      key={i}
                    >
                      <P>
                        <span>{suggestion.description}</span>
                      </P>
                    </SuggestionItem>
                  )
                })}
              </SuggestionContent>
            </SuggestionWrapper>
          )}
        </Wrapper>
      )}
    </PlacesAutocomplete>
  )
}

export default LocationSearchInput
